<div class="modal-overlay" (mousedown)="closed.emit()">
  <div
    class="modal-card sk-del-card"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="sk-del-title"
    aria-describedby="sk-del-body"
    (mousedown)="$event.stopPropagation()"
    (keydown.escape)="closed.emit()"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <div class="modal-head">
      <div>
        <div class="modal-sub">
          {{ 'skillManagement.delete.sub' | translate }}
        </div>
        <div class="modal-title" id="sk-del-title">
          {{
            'skillManagement.delete.title'
              | translate: { name: request.skill.faehigkeit }
          }}
        </div>
      </div>
      <button
        type="button"
        class="modal-x"
        (click)="closed.emit()"
        [attr.aria-label]="'general.close' | translate"
      >
        <app-skill-icon name="close" [size]="22" />
      </button>
    </div>

    <div class="modal-body" id="sk-del-body">
      <div class="sk-del-id">
        <span class="sk-del-id__name">
          <span>{{ request.skill.faehigkeit }}</span>
          @if (showEnglishName) {
            <span class="sk-hit-en"> · {{ request.skill.faehigkeitEn }}</span>
          }
        </span>
        <span class="sk-hit-cat">{{ request.skill.kategorie }}</span>
      </div>

      @if (used) {
        <div class="sk-del-warn">
          <app-skill-icon name="away" [size]="18" />
          <span
            [innerHTML]="
              'skillManagement.delete.warning'
                | translate
                  : {
                      tasks: (tasksKey | translate: { count: request.tasks }),
                      consultants:
                        (consultantsKey
                        | translate: { count: request.consultants }),
                    }
            "
          ></span>
        </div>
        @if (request.hasSimilar) {
          <div class="sk-del-alt">
            <span
              [innerHTML]="'skillManagement.delete.mergeInstead' | translate"
            ></span>
            <button type="button" class="tpl-btn" (click)="goToSimilar.emit()">
              <app-skill-icon name="merge" [size]="17" />{{
                'skillManagement.delete.goToSimilar' | translate
              }}
            </button>
          </div>
        }
        <label class="sk-del-ack">
          <input type="checkbox" [(ngModel)]="acknowledged" />
          <span>{{
            'skillManagement.delete.acknowledge'
              | translate
                : { tasks: (tasksKey | translate: { count: request.tasks }) }
          }}</span>
        </label>
      } @else {
        <p class="sk-del-ok">
          {{ 'skillManagement.delete.unused' | translate }}
        </p>
      }
    </div>

    <div class="modal-foot">
      <span class="modal-count">{{
        'skillManagement.delete.irreversible' | translate
      }}</span>
      <div class="modal-actions">
        <button
          type="button"
          class="btn-text"
          cdkFocusInitial
          (click)="closed.emit()"
        >
          {{ 'general.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn-danger"
          [disabled]="!canDelete"
          (click)="confirmed.emit()"
        >
          <app-skill-icon name="trash" [size]="16" />{{
            'skillManagement.delete.confirm' | translate
          }}
        </button>
      </div>
    </div>
  </div>
</div>
